import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class TypebotService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  loadTypebotScript() {
    const script = this.document.createElement('script');
    script.type = 'module';
    script.innerHTML = `
      import Typebot from 'https://cdn.jsdelivr.net/npm/@typebot.io/js@0.3.4/dist/web.js'
      Typebot.initBubble({
        typebot: "my-typebot-2tt90cv",
        apiHost: "https://bot.nuvoll.com",
        theme: { button: { backgroundColor: "#0042DA" } },
      });
    `;
    this.document.body.appendChild(script);
  }
}